import { Component, OnInit, ViewChild } from '@angular/core';
import { AdmihairBaseComponent } from '../../../admihair-base.component';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { NgForm } from '@angular/forms';
import { AnamneseService } from 'src/app/admihair/service/anamnese.service';
import { Anamnese } from 'src/app/admihair/api/dto/anamnese';

@Component({
  selector: 'app-anamnese-configuracao-inserir',
  templateUrl: './anamnese-configuracao-inserir.component.html',
  styleUrls: ['./anamnese-configuracao-inserir.component.scss']
})
export class AnamneseConfiguracaoInserirComponent extends AdmihairBaseComponent implements OnInit {

  progressoRequisicao: boolean = false;
  valorLgpd: boolean = false;
  @ViewChild('f') form?: NgForm;

  constructor(private anamneseService: AnamneseService,
    erroService: ErroService,
    storageService: UtilStorageService) {
        super(erroService, storageService)
       }

  ngOnInit(): void {
  }

  salvar() {
    this.progressoRequisicao = true;
    const anamneseRequest: Anamnese = this.form?.value;
    anamneseRequest.empresa = this.getEmpresa();
    this.anamneseService.salvar(anamneseRequest).subscribe({
      next: (data: Anamnese) => {
        this.progressoRequisicao = false;
        this.limparFormulario();
        this.exibirMensagemSucesso();
      },
      error: (err: any) => {
        this.progressoRequisicao = false;
        this.exibirMensagemErro(err);
      }
    })
  }

  limparFormulario(){
    this.form?.reset();
  }

}
